import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { ShoppingCart } from 'lucide-react';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const onSale =
    product.tags?.includes('sale') ||
    (product.originalPrice && product.originalPrice > product.price);

  return (
    <div className="group relative bg-zinc-950 border border-zinc-900 hover:border-[#909090]/60 rounded-md overflow-hidden flex flex-col transition-all duration-300 hover:shadow-[0_0_30px_-12px_rgba(144,144,144,0.5)]">
      <Link to={`/product/${product.slug}`} className="block relative aspect-square overflow-hidden bg-gradient-to-br from-zinc-900 to-black">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-contain p-4 transform group-hover:scale-105 transition-transform duration-500"
        />
        {onSale && (
          <span className="absolute top-3 left-3 bg-[#909090] text-black text-xs font-bold px-2.5 py-1 rounded-sm uppercase tracking-wide z-10">
            Sale
          </span>
        )}
        {/* Vial size ribbon — hide on accessories & supplements */}
        {product.category !== 'Accessories' && product.category !== 'Supplements' && (
          <span
            className="absolute top-3 right-0 bg-zinc-800 text-white text-[10px] font-bold uppercase tracking-widest pl-3 pr-2.5 py-1 shadow-md z-10"
            style={{ clipPath: 'polygon(8px 0, 100% 0, 100% 100%, 8px 100%, 0 50%)' }}
          >
            3ml Vial
          </span>
        )}
        {!product.inStock && (
          <span className="absolute bottom-3 right-3 bg-zinc-800 text-white text-xs font-medium px-2.5 py-1 rounded-sm z-10">
            Out of stock
          </span>
        )}
      </Link>

      <div className="p-4 flex flex-col flex-grow">
        <p className="text-[11px] uppercase tracking-widest text-zinc-500 mb-1">
          {product.category}
        </p>
        <Link to={`/product/${product.slug}`} className="text-white font-medium text-sm leading-snug mb-3 hover:text-[#909090] transition-colors min-h-[40px]">
          {product.name}
        </Link>

        <div className="flex items-baseline gap-2 mb-4 mt-auto">
          {onSale && product.originalPrice && (
            <span className="text-zinc-500 line-through text-sm">
              € {product.originalPrice.toFixed(2)}
            </span>
          )}
          <span className="text-[#909090] font-bold text-lg">
            € {product.price.toFixed(2)}
          </span>
        </div>

        {product.inStock ? (
          <button
            onClick={(e) => {
              e.preventDefault();
              addToCart(product, 1);
            }}
            className="flex items-center justify-center gap-2 w-full py-2.5 bg-transparent border border-[#909090] text-[#909090] hover:bg-[#909090] hover:text-black font-medium text-sm rounded transition-all duration-200"
          >
            <ShoppingCart size={16} /> Add to cart
          </button>
        ) : (
          <Link
            to={`/product/${product.slug}`}
            className="flex items-center justify-center w-full py-2.5 border border-zinc-700 text-zinc-400 font-medium text-sm rounded hover:border-zinc-500 transition-colors"
          >
            Read more
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
